import React from "react";
import { getWellnessBandIconKey } from "../constants/mediaAssets.js";
import { MENTAL_LOAD_INDEX_TITLE } from "../constants/wellness.js";
import MediaIcon from "./MediaIcon.js";

const WellnessScaleBlock = ({ score, label, helper, reasons, compact = false, hideScore = false }) => {
  if (score == null) return null;

  const displayReasons = compact
    ? (reasons || []).filter((r) => r.id !== "summary").slice(0, 3)
    : reasons || [];

  const hasReasons = displayReasons.length > 0;
  if (hideScore && !hasReasons) return null;

  return (
    <div className={`wellness-scale${hideScore ? " wellness-scale--reasons-only" : ""}`}>
      {!hideScore ? (
        <>
          <MediaIcon
            iconKey={getWellnessBandIconKey(score)}
            className="media-icon wellness-scale__band-icon"
            size={40}
            alt=""
          />
          <div className="wellness-scale__labels">
            <span>Strained</span>
            <span>Thriving</span>
          </div>
          <div
            className="wellness-scale__track"
            role="meter"
            aria-valuenow={score}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={`${MENTAL_LOAD_INDEX_TITLE}: ${score} out of 100, ${label}`}
          >
            <div className="wellness-scale__gradient" />
            <div className="wellness-scale__marker" style={{ left: `${score}%` }} title={`${score}/100`} />
          </div>
          <p className="wellness-scale__score">
            <strong>{score}</strong>
            <span className="wellness-scale__score-max"> / 100</span>
            <span className="wellness-scale__score-label"> — {label}</span>
            {helper ? <span className="wellness-scale__score-helper">{helper}</span> : null}
          </p>
        </>
      ) : null}

      {hasReasons ? (
        <div className="wellness-scale__reasoning" aria-label="Index reasoning">
          <h3 className="wellness-scale__reasoning-title">{compact ? "Why this index" : "How this index was calculated"}</h3>
          <ul className="wellness-scale__reasoning-list">
            {displayReasons.map((reason) => (
              <li
                key={reason.id}
                className={`wellness-scale__reason wellness-scale__reason--${reason.tone}${reason.id === "summary" ? " wellness-scale__reason--summary" : ""}`}
              >
                {reason.impact !== 0 ? (
                  <span className={`wellness-scale__impact wellness-scale__impact--${reason.tone}`}>
                    {reason.impact > 0 ? `+${reason.impact}` : reason.impact}
                  </span>
                ) : null}
                <span className="wellness-scale__reason-text">{reason.text}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default WellnessScaleBlock;
